var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('mainBanner'),_c('events'),_c('eventsMobile'),_c('features'),_c('customers'),_c('customersMobile'),_c('EventUsers'),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }